import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Button, Think} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'ev-click': this.toggleExpanded,
                'children': '切换展开状态'
            })
        ), 2, 'think-demo-collapse-actions'),
        _$cc(Think, {
            'title': '已思考（用时 6 秒）',
            'content': 'DeepSeek 在技术层面采用了混合专家模型（MoE）架构，能够在保持性能的同时降低推理成本。开源版本已经支持多轮对话、代码生成等功能，开发者可以直接部署使用。',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['extra'] = function($super) {
                            return (
                                _$ce(2, 'span', '思考深度：高', 16, 'think-demo-collapse-extra')
                            );
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em),
            'ev-$model:expanded': function($v) {
                $this.set('expanded', $v);
            },
            'expanded': $this.get('expanded')
        }),
        _$ce(2, 'div', [
            _$ct('\n        当前状态：'),
            this.get('expanded') ? '已展开' : '已折叠'
        ], 0, 'think-demo-collapse-status')
    ], 4, 'think-demo-collapse');
};